import { render, staticRenderFns } from "./regCounselor.vue?vue&type=template&id=86d6ecf8&scoped=true"
import script from "./regCounselor.vue?vue&type=script&lang=js"
export * from "./regCounselor.vue?vue&type=script&lang=js"
import style0 from "./regCounselor.vue?vue&type=style&index=0&id=86d6ecf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d6ecf8",
  null
  
)

export default component.exports